import { Helmet } from 'react-helmet-async';
import { TimelineEvent } from '../Timeline/Timeline';
import imageShare from './Assets/museum-share.png'

interface MetaTagsProps {
  activeEvent?: TimelineEvent | null;
}

const MetaTags: React.FC<MetaTagsProps> = ({ activeEvent }) => {
  const baseTitle = 'The Museum of Digital Influence - Explore the Evolution of Digital Media';
  const baseDescription = 'Capturing the key moments, innovations, and trends that have defined how we connect and influence online – from the rise of blogging to today.';
  const baseImage = imageShare;
  const currentUrl = window.location.href;

  if (!activeEvent) {
    return (
      <Helmet>
        <title>{baseTitle}</title>
        <meta name="title" content={baseTitle} />
        <meta name="description" content={baseDescription} />
        <meta property="og:title" content={baseTitle} />
        <meta property="og:description" content={baseDescription} />
        <meta property="og:image" content={baseImage} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={baseTitle} />
        <meta name="twitter:description" content={baseDescription} />
        <meta name="twitter:image" content={baseImage} />
      </Helmet>
    );
  }

  const title = `${activeEvent.title} (${activeEvent.year}) - The Museum of Digital Influence`;
  const description = `${activeEvent.title} (${activeEvent.year})`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={activeEvent.img} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="article" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={activeEvent.img} />
    </Helmet>
  );
};

export default MetaTags; 